var render, staticRenderFns
import script from "./field.form.vue?vue&type=script&lang=js&"
export * from "./field.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43ead62a')) {
      api.createRecord('43ead62a', component.options)
    } else {
      api.reload('43ead62a', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/dict/field_extension/form/field.form.vue"
export default component.exports